import { render } from "./UpdateMobileSettingView.vue?vue&type=template&id=fa3b2c5a"
import script from "./UpdateMobileSettingView.vue?vue&type=script&lang=js"
export * from "./UpdateMobileSettingView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__